import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <div className="min-h-screen bg-[#f5f4f0]">
      {/* Hero Section with Extended Circular Image */}
      <section className="relative pb-0 px-4 pt-8 bg-[#f5f4f0]">
        {/* Mobile Image - Visible only on mobile, placed above the heading */}
        <div className="block md:hidden mb-6 mx-auto" style={{ maxWidth: '90%' }}>
          <div 
            className="w-full overflow-hidden shadow-2xl"
            style={{ 
              height: '280px',
              borderRadius: '300px 300px 0 0'
            }}
          >
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/gah7jqow_iStock-1143730903.webp"
              alt="Family support and care"
              className="w-full h-full object-cover"
              style={{ objectPosition: '0% center' }}
            />
          </div>
        </div>

        {/* Hero Background with Animation - Rounded with padding - Rose color */}
        <div className="relative py-12 md:py-20 px-4 bg-[#e6c8c8] overflow-hidden rounded-3xl max-w-7xl mx-auto shadow-lg">
          {/* Animated Background - Sped up by another 15% */}
          <div 
            className="absolute inset-0 opacity-30 rounded-3xl"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1714636608872-048fc9231892?w=1600&q=80)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              animation: 'slowPan 21.7s ease-in-out infinite alternate'
            }}
          />
          
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
            {/* Left side - Empty space for circular image that extends down - Hidden on mobile */}
            <div className="hidden md:block"></div>
            
            {/* Right side - Headline */}
            <div className="text-white text-center md:text-left">
              <h1 
                className="text-5xl md:text-6xl leading-tight"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Support for every season of&nbsp;motherhood
              </h1>
            </div>
          </div>
        </div>

        {/* Extended Circular Image - Positioned Absolutely to Span Both Sections */}
        <div className="absolute left-0 top-0 w-1/2 h-full hidden md:flex items-start justify-center pt-8 pl-12 z-20 pointer-events-none">
          <div 
            className="w-full max-w-xl overflow-hidden shadow-2xl"
            style={{ 
              height: '720px',
              borderRadius: '500px 500px 0 0'
            }}
          >
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/gah7jqow_iStock-1143730903.webp"
              alt="Family support and care"
              className="w-full h-full object-cover pointer-events-auto"
              style={{ objectPosition: '0% center' }}
            />
          </div>
        </div>
      </section>

      {/* Journey Text Section - No white box, copy with CTA */}
      <section className="relative pt-2 md:pt-4 pb-8 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-start">
          {/* Left side - Empty for circular image overlap */}
          <div></div>
          
          {/* Right side - Journey Text with CTA */}
          <div className="pt-0 md:pt-4 text-center md:text-left">
            <div className="space-y-4 text-lg leading-relaxed text-black mb-6" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>No two experiences of motherhood are the same, and neither is the support you need.</p>
              <p>Some women are preparing to meet their baby.</p>
              <p>Some are gently preparing for the weeks after birth.</p>
              <p>Others have already welcomed their little one and are looking for someone to walk beside them as they find their footing.</p>
              <p>Wherever you are, we'll begin there.</p>
              <p>Every conversation and every session is an opportunity to pause, ask questions, explore what matters to you and understand your options, so you can make choices that feel right for you, your baby and your family.</p>
            </div>
            
            <Link
              to="/contact"
              className="inline-block bg-[#815863] text-white px-8 py-3 rounded-full tracking-wider text-sm hover:bg-[#4d6654] transition-all duration-300 hover:scale-110 hover:shadow-xl"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              GET IN TOUCH
            </Link>
          </div>
        </div>
      </section>

      {/* 3 Ways of Working Together */}
      <section className="pt-8 pb-4 md:pt-16 md:pb-12 px-4 bg-[#f5f4f0]">
        <div className="max-w-6xl mx-auto md:bg-white md:rounded-3xl md:shadow-lg md:p-12">
          <h2 
            className="text-4xl md:text-5xl text-center mb-8 md:mb-16"
            style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
          >
            Choose the support that feels right for you
          </h2>
          
          <div className="hidden md:grid md:grid-cols-3 gap-12">
            {/* Birth Preparation */}
            <div className="text-center">
              <div className="mb-6">
                {/* Purple Crystal Icon */}
                <div className="w-20 h-20 mx-auto flex items-center justify-center">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/l1298ej7_Screenshot%202026-07-22%20at%2017.57.25.png" 
                    alt="Purple Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <h3 
                className="text-3xl font-bold mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: '#e6c8c8' }}
              >
                The Grounded Birth
              </h3>
              <p className="text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                For women who want to prepare for birth feeling informed, grounded and connected to themselves.
              </p>
            </div>

            {/* Preparing for Postpartum */}
            <div className="text-center">
              <div className="mb-6">
                {/* Golden Crystal Icon */}
                <div className="w-20 h-20 mx-auto flex items-center justify-center">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/neypii23_Screenshot%202026-07-22%20at%2017.57.31.png" 
                    alt="Golden Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <h3 
                className="text-3xl font-bold mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: '#d8b96a' }}
              >
                The Prepared Nest
              </h3>
              <p className="text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                For women who want to prepare for the fourth trimester with intention, confidence and care.
              </p>
            </div>

            {/* The Reconnection */}
            <div className="text-center">
              <div className="mb-6">
                {/* Rose Crystal Icon */}
                <div className="w-20 h-20 mx-auto flex items-center justify-center">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/1yn15ga2_Screenshot%202026-07-22%20at%2017.57.36.png" 
                    alt="Rose Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <h3 
                className="text-3xl font-bold mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
              >
                The Reconnection
              </h3>
              <p className="text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                For women who want to feel cared for as they find their way into motherhood.
              </p>
            </div>
          </div>

          <div className="hidden md:block text-center mt-12">
            <p 
              className="text-lg mb-2"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}
            >
              Find out more below
            </p>
            <svg className="w-6 h-6 mx-auto animate-bounce" fill="none" stroke="#815863" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </section>

      {/* Birth Preparation Package */}
      <section className="pt-4 pb-20 md:pt-12 md:pb-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto bg-white rounded-3xl shadow-lg p-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left side - Text Content */}
          <div>
            {/* Mobile: Crystal icon and circular image above title */}
            <div className="block md:hidden mb-6">
              {/* Circular image centered */}
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/t7vflxbi_barrigao.webp"
                  alt="Birth preparation"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: 'center 40%' }}
                />
              </div>
              {/* Small crystal watermark above title */}
              <div className="text-center">
                <div className="w-8 h-8 mx-auto mb-3 opacity-40">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/l1298ej7_Screenshot%202026-07-22%20at%2017.57.25.png" 
                    alt="Purple Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
                <h2 
                  className="text-3xl leading-tight"
                  style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
                >
                  The Grounded<br />Birth
                </h2>
              </div>
            </div>

            {/* Desktop: Title only */}
            <h2 
              className="hidden md:block text-4xl md:text-5xl mb-4 leading-tight text-left"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
            >
              The Grounded Birth
            </h2>
            <p 
              className="hidden md:block text-xl mb-8 text-black italic"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              For women who want to prepare for birth feeling informed, grounded and connected to themselves.
            </p>

            <div className="space-y-4 mb-8 text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>Birth is a powerful threshold, a moment of profound transition as you move towards meeting your baby and becoming a mother.</p>
              <p>Preparing for birth is not about trying to control how your birth will unfold. It is about becoming informed, understanding your options and finding a deeper sense of trust in yourself and your body.</p>
              <p>Together, we'll explore both the practical and emotional aspects of birth while creating a personalised Birth Plan that reflects what matters most to you.</p>
              <p>Sessions are available online or in person.</p>
            </div>

            <h3 
              className="text-xl font-semibold mb-4 tracking-wider text-black"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              What's included
            </h3>
            <ul className="space-y-2 text-black mb-6" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <li>• A short pre-session questionnaire to help me understand you, your pregnancy and how I can best support you.</li>
              <li>• A two-hour session where we'll create your personalised Birth Plan together and you'll have plenty of space to ask questions.</li>
              <li>• Your completed Birth Plan to keep, which may include:</li>
              <li className="ml-6">• Understanding your birth options and preferences</li>
              <li className="ml-6">• The stages of labour & the physiology of birth</li>
              <li className="ml-6">• Comfort measures, breathing and relaxation techniques</li>
              <li className="ml-6">• Creating a calm and supportive birth environment</li>
              <li className="ml-6">• Emotional preparation and building self-trust</li>
              <li className="ml-6">• Connecting with your intuition and inner wisdom</li>
              <li className="ml-6">• Exploring any hopes, fears or questions you may have</li>
            </ul>

            <p className="text-lg font-semibold mb-8 text-black" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Investment: £120
            </p>

            <div className="text-center md:text-left">
              <Link
                to="/contact"
                className="inline-block bg-[#815863] text-white px-8 py-3 rounded-full tracking-wider text-sm hover:bg-[#4d6654] transition-all duration-300 hover:scale-110 hover:shadow-xl"
                style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
              >
                BOOK A CONNECTION CALL
              </Link>
            </div>
          </div>

          {/* Right side - Image - Desktop only */}
          <div className="hidden md:block relative h-[700px]">
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/t7vflxbi_barrigao.webp"
              alt="Birth preparation"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
              style={{ objectPosition: 'center 30%' }}
            />
          </div>
          </div>
        </div>
      </section>


      {/* Preparing for Postpartum Package */}
      <section className="py-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto bg-white rounded-3xl shadow-lg p-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left side - Image - Desktop only */}
          <div className="hidden md:block relative h-[700px] order-2 md:order-1 overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/o1tfcy0h_Rest_barefeet%20%281%29.webp"
              alt="Grounded and connected"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right side - Text Content */}
          <div className="order-1 md:order-2">
            {/* Mobile: Crystal icon and circular image above title */}
            <div className="block md:hidden mb-6">
              {/* Circular image centered */}
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/o1tfcy0h_Rest_barefeet%20%281%29.webp"
                  alt="Grounded and connected"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Small crystal watermark above title */}
              <div className="text-center">
                <div className="w-8 h-8 mx-auto mb-3 opacity-40">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/neypii23_Screenshot%202026-07-22%20at%2017.57.31.png" 
                    alt="Golden Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
                <h2 
                  className="text-3xl leading-tight"
                  style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
                >
                  The Prepared<br />Nest
                </h2>
              </div>
            </div>

            {/* Desktop: Title only */}
            <h2 
              className="hidden md:block text-4xl md:text-5xl mb-4 leading-tight text-left"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
            >
              The Prepared Nest
            </h2>
            <p 
              className="hidden md:block text-xl mb-8 text-black italic"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              For women who want to prepare for the fourth trimester with intention, confidence and care.
            </p>

            <div className="space-y-4 mb-8 text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>As you prepare to welcome your baby, it's natural for much of your attention to be on the birth itself. Yet the weeks that follow are just as important, and deserve their own care, intention and preparation.</p>
              <p>The postpartum period is a time of profound change, healing and adjustment. Together, we'll create a personalised Fourth Trimester Plan that reflects your family, your values and the kind of care that will help you feel nourished, cared for and gently held as you step into motherhood.</p>
              <p>Sessions are available online or in person.</p>
            </div>

            <h3 
              className="text-xl font-semibold mb-4 tracking-wider text-black"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              What's included
            </h3>
            <ul className="space-y-2 text-black mb-6" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <li>• A short pre-session questionnaire to help me understand you, your pregnancy and how I can best support you.</li>
              <li>• A two-hour session where we'll create your personalised Fourth Trimester Plan together and you'll have plenty of space to ask questions.</li>
              <li>• Your completed Fourth Trimester Plan to keep, which may include:</li>
              <li className="ml-6">• Creating your postpartum support network</li>
              <li className="ml-6">• Preparing family and friends to support you well</li>
              <li className="ml-6">• Planning nourishing meals and practical help at home</li>
              <li className="ml-6">• Protecting time for rest, recovery and bonding</li>
              <li className="ml-6">• Preparing for your feeding journey and where to seek support</li>
              <li className="ml-6">• Navigating visitors and setting healthy boundaries</li>
              <li className="ml-6">• Supporting your physical and emotional wellbeing</li>
            </ul>

            <p className="text-lg font-semibold mb-8 text-black" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Investment: £120
            </p>

            <div className="text-center md:text-left">
              <Link
                to="/contact"
                className="inline-block bg-[#815863] text-white px-8 py-3 rounded-full tracking-wider text-sm hover:bg-[#4d6654] transition-all duration-300 hover:scale-110 hover:shadow-xl"
                style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
              >
                BOOK A CONNECTION CALL
              </Link>
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* The Reconnection Package */}
      <section className="py-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto bg-white rounded-3xl shadow-lg p-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left side - Text Content */}
          <div>
            {/* Mobile: Crystal icon and circular image above title */}
            <div className="block md:hidden mb-6">
              {/* Circular image centered */}
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/ad1j2b37_iStock-1845490220.webp"
                  alt="The Reconnection"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Small crystal watermark above title */}
              <div className="text-center">
                <div className="w-8 h-8 mx-auto mb-3 opacity-40">
                  <img 
                    src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/1yn15ga2_Screenshot%202026-07-22%20at%2017.57.36.png" 
                    alt="Rose Crystal"
                    className="w-full h-full object-contain"
                  />
                </div>
                <h2 
                  className="text-3xl leading-tight"
                  style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
                >
                  The<br />Reconnection
                </h2>
              </div>
            </div>

            {/* Desktop: Title only */}
            <h2 
              className="hidden md:block text-4xl md:text-5xl mb-4 leading-tight text-left"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
            >
              The Reconnection
            </h2>
            <p 
              className="text-xl mb-8 text-black italic"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              For women who want to feel cared for as they find their way into motherhood.
            </p>

            <div className="space-y-4 mb-8 text-black leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>There was a time when new mothers were surrounded by their village. They were cared for, nourished and given the time to rest, recover and simply be with their baby.</p>
              <p>Today, many women experience those early weeks very differently. Families often live far apart, support can be limited, and the expectation to keep going can feel overwhelming.</p>
              <p>When a baby is born, a mother is born too. And when she is cared for, she has more space to rest, recover and be fully present for herself, her baby and her family.</p>
              <p>The Reconnection is my way of bringing a little of that village back.</p>
              <p>My role is to create a space where you can feel truly cared for. A space that feels warm, safe and unhurried. A little like coming home to your grandmother's house, where there's always something nourishing on the stove, a warm cup of tea waiting, and someone who looks you in the eyes and asks how you really are.</p>
              <p>There is no set agenda for our time together. Each visit is guided by what you and your family need most on the day, offering practical help, emotional care and a reassuring presence as you settle into motherhood.</p>
            </div>

            <h3 
              className="text-xl font-semibold mb-4 tracking-wider text-black"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              A few ways I can support you
            </h3>
            <ul className="space-y-2 text-black mb-6" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <li>• Preparing nourishing meals and snacks.</li>
              <li>• Helping with light tasks around the home.</li>
              <li>• Holding your baby while you rest, shower or take a moment for yourself.</li>
              <li>• Offering a listening ear and emotional support.</li>
              <li>• Making space for your feelings, without judgement or expectation.</li>
              <li>• Supporting you as you find your rhythm with your baby.</li>
              <li>• Creating space for rest, recovery and bonding.</li>
            </ul>

            <p className="text-lg font-semibold mb-2 text-black" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Investment: £25 per hour
            </p>
            <p className="text-base mb-8 text-black" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Offered by the hour, with a minimum booking of three hours.
            </p>

            <div className="text-center md:text-left">
              <Link
                to="/contact"
                className="inline-block bg-[#815863] text-white px-8 py-3 rounded-full tracking-wider text-sm hover:bg-[#4d6654] transition-all duration-300 hover:scale-110 hover:shadow-xl"
                style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
              >
                BOOK A CONNECTION CALL
              </Link>
            </div>
          </div>

          {/* Right side - Image - Desktop only */}
          <div className="hidden md:block relative h-[800px]">
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/ad1j2b37_iStock-1845490220.webp"
              alt="The Reconnection"
              className="w-full h-full object-cover rounded-lg shadow-2xl"
            />
          </div>
          </div>
        </div>
      </section>

      {/* The Process Section */}
      <section className="relative py-20 px-4 bg-[#e6c8c8]">
        {/* Organic wavy shape at top with smaller, more frequent curves */}
        <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
          <svg className="relative block w-full h-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0 Q50,30 100,20 T200,20 T300,20 T400,20 T500,20 T600,20 T700,20 T800,20 T900,20 T1000,20 T1100,20 T1200,20 V0 Z" fill="#f5f4f0"></path>
          </svg>
        </div>
        
        <div className="max-w-6xl mx-auto relative z-10">
          <h2 className="text-3xl md:text-4xl text-center mb-16 text-[#6b4545]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Here's what working together might look like
          </h2>
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              {/* Colored circle - Sage Green */}
              <div className="w-4 h-4 rounded-full mx-auto mb-6" style={{ backgroundColor: '#4d6654' }}></div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#6b4545] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Everything starts with a relaxed Connection Call.
              </h3>
              <div className="space-y-3 text-[#6b4545] leading-relaxed text-base" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                <p>It's a chance for us to get to know each other, for you to share where you are, ask any questions you may have, and explore what kind of support feels right, without any pressure or expectation.</p>
              </div>
            </div>
            <div className="text-center">
              {/* Colored circle - Golden */}
              <div className="w-4 h-4 rounded-full mx-auto mb-6" style={{ backgroundColor: '#d8b96a' }}></div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#6b4545] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Together, we'll find the support that's right for you.
              </h3>
              <div className="space-y-3 text-[#6b4545] leading-relaxed text-base" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                <p>Whether you're preparing for birth, preparing for the fourth trimester, looking for in-home postpartum support, or would benefit from a combination of these, we'll explore what feels right for your unique season.</p>
                <p>Your support is always shaped around you, never the other way around.</p>
              </div>
            </div>
            <div className="text-center">
              {/* Colored circle - Mauve */}
              <div className="w-4 h-4 rounded-full mx-auto mb-6" style={{ backgroundColor: '#815863' }}></div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#6b4545] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Then, we'll walk this part of the journey together.
              </h3>
              <div className="space-y-3 text-[#6b4545] leading-relaxed text-base" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
                <p>From there, I'll be by your side with gentle, personalised support that meets you where you are, helping you feel informed when you need clarity, prepared for what's ahead, and cared for as you find your own way into motherhood.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <div className="py-8 px-4 bg-[#f5f4f0] text-center">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-flex items-center gap-2 text-[#815863] hover:text-[#4d6654] transition-colors duration-300"
          style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          Back to Top
        </button>
      </div>
    </div>
  );
};

export default Services;
